import React from 'react'

const CustomPageShare = ({ color = '#fff', style = { width: '23.758px', height: '23.758px' } }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} viewBox="0 0 23.758 23.758">
      <path
        data-name="Path 1413"
        d="M22.253 6.626A3.626 3.626 0 1 1 18.626 3a3.626 3.626 0 0 1 3.627 3.626z"
        transform="translate(.505 -2)"
        style={{ fill: 'none', stroke: color, strokeWidth: '2px' }}
      />
      <path
        data-name="Path 1414"
        d="M22.253 18.626A3.626 3.626 0 1 1 18.626 15a3.626 3.626 0 0 1 3.627 3.626z"
        transform="translate(.505 .505)"
        style={{ fill: 'none', stroke: color, strokeWidth: '2px' }}
      />
      <path
        data-name="Path 1415"
        d="M10.253 12.626A3.626 3.626 0 1 1 6.626 9a3.626 3.626 0 0 1 3.627 3.626z"
        transform="translate(-2 -.747)"
        style={{ fill: 'none', stroke: color, strokeWidth: '2px' }}
      />
      <path
        data-name="Path 1416"
        d="m8.72 11.3 7.59-3.8"
        transform="translate(-.806 -1.061)"
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          fill: 'none',
          stroke: color,
          strokeWidth: '2px',
        }}
      />
      <path
        data-name="Path 1417"
        d="m8.706 13.353 7.608 3.8"
        transform="translate(-.809 .161)"
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          fill: 'none',
          stroke: color,
          strokeWidth: '2px',
        }}
      />
    </svg>
  )
}

export default CustomPageShare
